<template>
    <div class="row">
        <div class="col-12 col-sm pr-sm-0">
            <input class="form-control form-control-lg" type="text" autocomplete="off" aria-label="Search" placeholder="Введіть номер матеріалу"
                   @keyup.enter="search" v-model="code" />
        </div>
        <div class="col-12 col-sm-auto pl-sm-0" style="margin-left: -40px;">
            <button class="btn btn-lg btn-success my-2 my-sm-0 text-light" @click="search">Знайти</button> <!-- Пошук -->
        </div>
    </div>
</template>

<script>
    export default {
        name: 'video-search',
        data() {
            return {
                code: '', // 00010
                packageItem: {}
            };
        },
        methods: {
            search() {
                juniorApi.get(`public/video/search/${this.code}`).then(response => {
                    this.packageItem = response.data.gist;
                    this.$emit('afterVideoSearch', this.packageItem);
                });
            }
        }
    }
</script>

<style scoped>
    input[type=text] { border-radius: 5rem; }
    button { border-radius: 5rem; }
    .form-control:focus { box-shadow: none; }
</style>